import React from 'react'
import { connect } from 'react-redux';
import { Drawer, Button, Modal, Select } from 'antd';
import { languageSelector } from '../../Redux/Reducers/settingsReducer';
import { localization } from '../../Utils/Localization/localization';
import { IOrder } from '../../Utils/types';
import {
  currentOrderSelector,
  getCurrentOrder,
  changeStatus,
  currentOrderStatusSelector
} from '../../Redux/Reducers/ordersReducer';
import classes from './ViewOrderDrawer.module.scss';
import { convertStatus } from '../../Utils/convertStatus';
import { userLevelSelector } from '../../Redux/Reducers/userReducer';

interface StateProps {
  language: string,
  order: IOrder,
  status: string,
  level: number
}
interface DispatchProps {
  getCurrentOrder: (id: number) => void,
  handleRemove: (id: number) => void,
  changeStatus: (id: number, status: number) => void
}
interface Props extends StateProps, DispatchProps {
  visible: boolean,
  handleClose: () => void,
  orderId: number
}

function ViewOrderDrawer(props: Props) {
  const [editModal, setEditModal] = React.useState<boolean>(false);
  const [newStatus, setNewStatus] = React.useState<number>(0);
  const permissionLevel = props.level >= 2;

  React.useEffect(() => {
    if (props.orderId !== 0) {
      props.getCurrentOrder(props.orderId);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.orderId]);

  React.useEffect(() => {
    if (props.status === 'valid') {
      handleEdit();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.status]);

  function handleEdit() {
    setEditModal(!editModal);
  }

  function handleStatus() {
    props.changeStatus(props.order.id, newStatus);
  }

  function confirmRemove() {
    Modal.confirm({
      title: localization('delete', props.language) + '?',
      onOk() {
        props.handleRemove(props.order.id);
      },
      onCancel() { }
    });
  }

  function renderOrderInfo() {
    return (
      <div className={classes.Order}>
        <span>{`${localization('userId', props.language)}: ${props.order.userId}`}</span>
        <h4>{`${localization('price', props.language)}: ${props.order.price} RUB`}</h4>
        <h3>{localization('goods', props.language)}</h3>
        <ul>
          {
            props.order.products.map((item) => {
              return (
                <li className={classes.Product} key={item.id}>
                  <div>
                    <img src={item.photourl.huge} alt="" />
                  </div>
                  <div>
                    <span>{item.name}</span>
                  </div>
                  <div>
                    <span>{item.quantity}</span>
                  </div>
                  <div>
                    <span>{item.price * item.quantity} RUB</span>
                  </div>
                </li>
              );
            })
          }
        </ul>
        <Button
          type={'primary'}
          onClick={handleEdit}
          disabled={!permissionLevel}
        >
          {localization('editStatus', props.language)}
        </Button>
        <Button
          type={'danger'}
          onClick={confirmRemove}
          disabled={!permissionLevel}
        >
          {localization('delete', props.language)}
        </Button>
      </div>
    );
  }

  return (
    <Drawer
      width={window.screen.width <= 600 ? '70%' : '40%'}
      title={`${localization('orderDescription', props.language)}: ${props.order.id}`}
      onClose={props.handleClose}
      visible={props.visible}
    >
      <Modal
        title={localization('editStatus', props.language)}
        visible={editModal}
        onCancel={handleEdit}
        footer={[
          <Button
            onClick={handleEdit}
            key='back'
          >
            {localization('cancel', props.language)}
          </Button>,
          <Button
            onClick={handleStatus}
            key='submit'
            loading={props.status === 'loading'}
          >
            {localization('done', props.language)}
          </Button>
        ]}
      >
        <Select
          defaultValue={localization(convertStatus(props.order.status), props.language)}
          onChange={(value) => setNewStatus(value)}
        >
          {
            [0, 1, 2].map((item) => {
              return (
                <Select.Option
                  value={item}
                  key={item}
                >
                  {localization(convertStatus(item), props.language)}
                </Select.Option>
              );
            })
          }
        </Select>

      </Modal>
      {
        props.order
          ? renderOrderInfo()
          : localization('wait', props.language)
      }
    </Drawer>
  );
}

function mapStateToProps(state: any) {
  return {
    language: languageSelector(state),
    order: currentOrderSelector(state),
    status: currentOrderStatusSelector(state),
    level: userLevelSelector(state)
  }
}
const mapDispatchToProps = {
  getCurrentOrder,
  changeStatus
}

const ConnectedViewOrderDrawer = connect(mapStateToProps, mapDispatchToProps)(ViewOrderDrawer);
export { ConnectedViewOrderDrawer as ViewOrderDrawer };